import { CRM_DEAL_STATE_LABELS, CRM_READ_STATE_LABELS, type CrmDealState, type CrmReadState } from '@lia/contracts';
import { StatusBadge, type StatusTone } from '../primitives/badge.js';

// CRM side of an opportunity (setter §08.1, §08.2, §08.7, §08.8): deal link state and the last live CRM read. States are
// exactly what the CRM confirmed — «vinculado» only after the CRM returned the id; a failed read says LIA operated locally.

export const CRM_DEAL_STATE_TONE: Record<CrmDealState, StatusTone> = {
  none: 'neutral',
  linked: 'success',
  ambiguous: 'warning',
  failed: 'danger',
  unsupported: 'neutral',
  disabled: 'neutral',
};

export const CRM_READ_STATE_TONE: Record<CrmReadState, StatusTone> = {
  ok: 'success',
  error: 'warning',
  unsupported: 'neutral',
  never: 'neutral',
};

export function CrmDealBadge({ state }: { state: CrmDealState }) {
  return <StatusBadge tone={CRM_DEAL_STATE_TONE[state]}>{CRM_DEAL_STATE_LABELS[state]}</StatusBadge>;
}

export function CrmReadBadge({ state }: { state: CrmReadState }) {
  return <StatusBadge tone={CRM_READ_STATE_TONE[state]}>{CRM_READ_STATE_LABELS[state]}</StatusBadge>;
}

/** «Siguiente acción» line: the concrete next step, or an explicit warning when nothing is scheduled. */
export function NextActionSummary({ label, when, owner, missing }: { label: string | null; when: string | null; owner: string | null; missing: boolean }) {
  if (missing) return <StatusBadge tone="warning">Sin siguiente acción programada</StatusBadge>;
  if (!label) return <span className="text-text-secondary">Sin siguiente acción (oportunidad cerrada)</span>;
  return (
    <span className="grid gap-0.5">
      <span className="break-words text-text-primary">{label}</span>
      {when || owner ? <span className="text-meta text-text-secondary">{[when, owner ? `Responsable: ${owner}` : null].filter(Boolean).join(' · ')}</span> : null}
    </span>
  );
}
